import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TextTransformService {

  transformarAMayusculas(datos: any): any {
    const datosMayusculas: any = {};
    for (const key in datos) {
      if (datos.hasOwnProperty(key)) {
        const valor = datos[key];

        if (typeof valor === 'string') {
          datosMayusculas[key] = valor.toUpperCase();
        } else if (valor != null) {
          if (typeof valor === 'object') {
            if (Array.isArray(valor) && valor.length > 0 && valor[0]?.direccionNotificacion) {
              datosMayusculas[key] = valor.map(item => ({
                ...item,
                direccionNotificacion: item.direccionNotificacion.toUpperCase()
              }));
            }  else if (key === 'municipio' && valor?.departamento && valor?.municipio) {
              datosMayusculas[key] = {
                ...valor,
                departamento: valor.departamento.toUpperCase(),
                municipio: valor.municipio.toUpperCase()
              };
            } else {
              datosMayusculas[key] = valor;
            }
          } else {
            datosMayusculas[key] = valor;
          }
        } else {
          datosMayusculas[key] = valor;
        }
      }
    }

    return datosMayusculas;
  }
}